import { useRequiredContext } from "@redotech/react-util/context";
import {
  RETURNS_SETTINGS_TAB_BY_LEGACY_PATH,
  RETURNS_SETTINGS_TAB_QUERY_PARAM,
  type ReturnsSettingsTab,
} from "@redotech/redo-settings-common/flat-team-settings/returns/returns-settings-tab";
import { RETURNS_CONSOLIDATED_SETTINGS_PATH } from "@redotech/redo-settings-common/flat-team-settings/returns/settings-paths";
import { MerchantRoutesContext } from "../merchant-routes";

export function returnsSettingsTabPath(tab: ReturnsSettingsTab): string {
  return `${RETURNS_CONSOLIDATED_SETTINGS_PATH}?${RETURNS_SETTINGS_TAB_QUERY_PARAM}=${tab}`;
}

/** Where a page under an old returns page goes back to: the tab that replaced it, else the page itself. */
export function returnsSettingsParentPath(legacyPath: string): string {
  const tab = RETURNS_SETTINGS_TAB_BY_LEGACY_PATH[legacyPath];
  return tab ? returnsSettingsTabPath(tab) : legacyPath;
}

export function useReturnsSettingsParentHref(legacyPath: string): string {
  const routes = useRequiredContext(MerchantRoutesContext);
  return routes.getSettingsSubRoute(returnsSettingsParentPath(legacyPath));
}
